import { schoolPickerMixin } from './document/schoolPicker';

export const schoolPickerSecretaryMixin = {
  mixins: [schoolPickerMixin],
  props: {
    // Model szkoły
    schoolModel: { type: Object, required: true },

    // Czy pobierać również zespoły
    withParents: { type: Boolean, default: false }
  },
  data() {
    return { isSecretary: true };
  },
  mounted() {
    this.getSecretaryNodes();
  },
  methods: {
    // @vuese
    // Wyszukuje szkoły
    search(search) {
      if (this.isSecretary) {
        return;
      }
      this.$store
        .dispatch('structureNode/list', { search, hasParentOrChildren: this.withParents, hasParent: !this.withParents })
        .then(result => (this.options = result.list));
    },

    // @vuese
    // Aktualizuje dane szkoły
    updateSchoolData(node) {
      this.schoolModel.nodeId.$setData(node.id);
    },

    // @vuese
    // Pobiera szkoły sekretarki
    getSecretaryNodes() {
      const nodes = this.filterNodes(this.$store.state.auth.nodes);
      if (nodes?.length) {
        this.options = nodes;
        if (nodes.length === 1) {
          this.updateSchoolData(nodes[0]);
        }
        return;
      }
      this.isSecretary = false;
      return this.search();
    },

    // @vuese
    // Filtruje dostępne węzły
    filterNodes(nodes) {
      if (this.withParents) {
        return nodes.filter(node => (node.isSingle && !!node.parentId) || (!node.isSingle && !node.parentId));
      }
      return nodes.filter(node => !!node.parentId);
    }
  }
};
